var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ scrollLock: _vm.scrollLock },on:{"click":_vm.closeChatbot}},[_c(this.$route.meta.layout || 'div',{tag:"component",attrs:{"dark":this.$route.meta.dark}},[_c('router-view')],1),_c('cookie-law',{staticClass:"v-application",attrs:{"theme":"jobstairs","storageType":"cookies"},on:{"accept":_vm.enableTracking}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }